export const LOGIN_ROUTE = '/auth/login';
export const PAZIENTI_ROUTE = '/dashboard/pazienti';
export const UTENTI_APP_ROUTE = '/dashboard/utenti-app';
export const VISUALIZZA_PAZIENTI_ROUTE = '/dashboard/pazienti/visualizza-paziente';
export const GETFORM_ROUTE = '/admin/dynamic-form/get-form';
export const GETFORM_ROUTE_URL = 'admin/dynamic-form/get-form';
export const HOME_ROUTE = '';

export const ORDER_ASC = 'ASC';
export const ORDER_DESC = 'DESC';

export const DEFAULT_VISITA_CHIRURGO_ID = 1;
export const DEFAULT_VISITA_NUTRIZIONISTA_ID = 2;
export const DEFAULT_VISITA_PSICOLOGO_ID = 3;
export const DEFAULT_RIVALUTAZIONE_MULTIDISPIPLINARE_ID = 5;
export const DEFAULT_DIMISSIONI_ID = 7;

export const DEFAULT_HOURS_MINUTES = '00:00';

export const DAYS_OF_WEEK = [
  { it: 'Lunedì', en: 'Monday' },
  { it: 'Martedì', en: 'Tuesday' },
  { it: 'Mercoledì', en: 'Wednesday' },
  { it: 'Giovedì', en: 'Thursday' },
  { it: 'Venerdì', en: 'Friday' },
  { it: 'Sabato', en: 'Saturday' },
  { it: 'Domenica', en: 'Sunday' }
];

//constanti route visita-nutrizionista
export const NUTRITIONIST_VISIT = 'nutritionist-visit';
export const NUTRITIONIST_ANALYSIS = 'nutritionist-analysis';
export const NUTRITIONIST_DAY = 'nutritionist-day';
export const NUTRITIONIST_NUTRITION = 'nutritionist-nutrition';
export const NUTRITIONIST_MEALS = 'nutritionist-meals';
export const NUTRITIONIST_FOODS = 'nutritionist-foods';

//constanti route visita-chilurgo
export const SURGEON_VISIT = 'surgeon-visit';
export const SURGEON_ANAMNESIS = 'surgeon-anamnesis';
export const SURGEON_INTERVENTION_ANALYSIS = 'surgeon-intervention-analysis';
export const SURGEON_LOCATION = 'surgeon-location';

//constanti route visita-psicologo
export const PSYCHOLOGIST_VISIT = 'psychologist-visit';
export const PSYCHOLOGIST_TEST = 'psychologist-test';

//constanti route rivalutazione-multidisciplinare
export const MULTIDISCIPLINARY_REEVALUATION = 'multidisciplinary-re-evaluation';
export const MULTIDISCIPLINARY_REEVALUATION_TEST = 'multidisciplinary-re-evaluation-test';

//costanti per search nella select
export const searchableFields = [
  'patient',
  'paziente',
  'doctor',
  'medico',
  'structure',
  'struttura',
  'sede',
  'location',
  'prerecovery_location',
  'surgery_location',
  'doctor_office_id',
  'structure_modal',
  'associated_patient',
  'birth_place',
  'city',
  'comune',
  'birth_city'
];
